module.exports = __webpack_public_path__ + "static/media/circle.4efcc37b.svg";